import { useRef } from 'react';
import type { IGlobalContextFields } from '@/utils/analytics/analytics.interface';

/**
 * Returns a ref that always holds the latest global context values.
 */
export const useGlobalContextFieldsRef = (fields: IGlobalContextFields) => {
  const { cartCount, locale, currentDevice, pageId, pcOptimumAccount } = fields;
  const globalContextFieldsRef = useRef<IGlobalContextFields>({
    cartCount: 0,
    locale: '',
    currentDevice: '',
    pageId: '',
    pcOptimumAccount: null,
  });

  globalContextFieldsRef.current.cartCount = cartCount;
  globalContextFieldsRef.current.locale = locale;
  globalContextFieldsRef.current.currentDevice = currentDevice;
  globalContextFieldsRef.current.pageId = pageId;
  globalContextFieldsRef.current.pcOptimumAccount = pcOptimumAccount;

  return globalContextFieldsRef;
};
